import { useNavigate } from 'react-router-dom';
import React from 'react';

// HOC para inyectar navigate en componentes de clase
export function withClassNavigate(Component) {
  return function Wrapper(props) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
}
